/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Cover_HeadlineInputs */

const en_us2_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your last week`)
};

const pt_br2_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua semana passada`)
};

const es_419_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu semana pasada`)
};

const pt_pt2_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua semana passada`)
};

const fr_fr2_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta semaine dernière`)
};

const de_de2_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine letzte Woche`)
};

const it_it2_wrapped_cover_headline = /** @type {(inputs: Wrapped_Cover_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua ultima settimana`)
};

/**
* | output |
* | --- |
* | "Your last week" |
*
* @param {Wrapped_Cover_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_cover_headline = /** @type {((inputs?: Wrapped_Cover_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Cover_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_cover_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_cover_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_cover_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_cover_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_cover_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_cover_headline(inputs)
	return en_us2_wrapped_cover_headline(inputs)
});
export { wrapped_cover_headline as "wrapped.cover_headline" }